<template>
  <div>
    <v-row>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.CNPJ">
        <v-row class="text-subtitle font-weight-bold"> CNPJ </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.CNPJ.Numero }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.DataFundacao">
        <v-row class="text-subtitle font-weight-bold"> Data fundação </v-row>
        <v-row class="text-subtitle"> {{ $api.UI.Format.Date(model.Consumidor.ConsumidorPessoaJuridica.DataFundacao) }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.SituacaoCNPJ?.DescricaoSituacao">
        <v-row class="text-subtitle font-weight-bold"> Situação CNPJ </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.SituacaoCNPJ.DescricaoSituacao }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.SituacaoCNPJ?.DataSituacao">
        <v-row class="text-subtitle font-weight-bold"> Data da situaçao </v-row>
        <v-row class="text-subtitle"> {{ $api.UI.Format.Date(model.Consumidor.ConsumidorPessoaJuridica.SituacaoCNPJ.DataSituacao) }} </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.NomeComercial && model.Consumidor?.ConsumidorPessoaJuridica?.NomeComercial != ' '">
        <v-row class="text-subtitle font-weight-bold"> Nome Comercial </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.NomeComercial }} </v-row>
      </v-col>
      <v-col cols="6" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.RazaoSocial">
        <v-row class="text-subtitle font-weight-bold"> Razão Social </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.RazaoSocial }} </v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="model.GrafiaPJ?.DetalheGrafiaPJ?.length">Grafia</span>
    <v-row
      v-for="(item, index) in model.GrafiaPJ?.DetalheGrafiaPJ"
      :key="item.RazaoSocial + '-' + index"
      class="mb-2"
    >
      <v-col cols="6" v-if="item.RazaoSocial">
        <v-row class="text-subtitle font-weight-bold">Razão Social {{ index + 1 }}</v-row>
        <v-row class="text-subtitle">{{ item.RazaoSocial }}</v-row>
      </v-col>
    </v-row>
    <span class="text-h5 ml-3 primary--text" v-if="
      model.Consumidor?.ConsumidorPessoaJuridica?.NaturezaJuridica?.Codigo ||
      model.Consumidor?.ConsumidorPessoaJuridica?.AtividadeEconomicaPrincipal?.Codigo ||
      model.Consumidor?.ConsumidorPessoaJuridica?.AtividadeEconomicaSecundaria?.length"> Natureza Jurídica e Atividades Econômicas
    </span>
    <v-row>
      <v-col cols="6" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.NaturezaJuridica?.Codigo">
        <v-row class="text-subtitle font-weight-bold">Natureza Jurídica</v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.NaturezaJuridica.Codigo + ' - ' + model.Consumidor.ConsumidorPessoaJuridica.NaturezaJuridica.Descricao }} </v-row>
      </v-col>
      <v-col cols="6" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.AtividadeEconomicaPrincipal?.Codigo">
        <v-row class="text-subtitle font-weight-bold">Atividade Econômica Principal</v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor?.ConsumidorPessoaJuridica?.AtividadeEconomicaPrincipal?.Codigo + ' - ' + model.Consumidor.ConsumidorPessoaJuridica.AtividadeEconomicaPrincipal.Descricao }} </v-row>
      </v-col>
    </v-row>
    <v-row class="text-subtitle font-weight-bold ml-3" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.AtividadeEconomicaSecundaria?.length">Atividades Econômicas Secundárias</v-row>
    <v-row
      v-for="(item, index) in model.Consumidor?.ConsumidorPessoaJuridica?.AtividadeEconomicaSecundaria"
      :key="item.Codigo + '-' + index"
    >
      <v-col cols="12" v-if="item.Codigo">
        <v-row class="text-subtitle"> • {{ item.Codigo + ' - ' + item.Descricao }}</v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="model?.AtividadeEmpresa?.DetalheAtividadeEmpresa?.length">Atividades Empresa</span>
    <v-row class="text-subtitle font-weight-bold ml-3" v-if="model?.AtividadeEmpresa?.DetalheAtividadeEmpresa?.length">Ramo de Atividade</v-row>
    <v-row
      v-for="(item, index) in model?.AtividadeEmpresa?.DetalheAtividadeEmpresa"
      :key="item.RamoAtividade.Codigo + '-' + index"
    >
      <v-col cols="12" v-if="item.RamoAtividade?.Codigo">
        <v-row class="text-subtitle"> • {{ item.RamoAtividade.Codigo + ' - ' + item.RamoAtividade.Descricao }}</v-row>
      </v-col>
    </v-row>
    <v-row class="text-subtitle font-weight-bold ml-3" v-if="model?.AtividadeEmpresa?.DetalheAtividadeEmpresa?.length">Atividades Secundárias</v-row>
    <v-row
      v-for="(detalhe, i) in model?.AtividadeEmpresa?.DetalheAtividadeEmpresa"
      :key="'detalhe-' + i"
    >
      <v-col
        v-for="(atividade, j) in detalhe.AtividadesEconomicasSecundarias"
        :key="atividade.Codigo + '-' + j"
        cols="12"
      >
        <v-row class="text-subtitle">
          • {{ atividade.Codigo }} - {{ atividade.Descricao }}
        </v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Email">E-mail</span>
    <v-row>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Email">
        <v-row class="text-subtitle font-weight-bold"> E-mail </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.Email }} </v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="
      model.Consumidor?.ConsumidorPessoaJuridica?.Fax ||
      model.Consumidor?.ConsumidorPessoaJuridica?.Telefone"
    >
      Telefones
    </span>
    <v-row>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Telefone">
        <v-row class="text-subtitle font-weight-bold"> Residencial </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.Telefone.NumeroDDD + ' ' + model.Consumidor.ConsumidorPessoaJuridica.Telefone.Numero }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Fax">
        <v-row class="text-subtitle font-weight-bold"> Fax </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.Fax.NumeroDDD + ' ' + model.Consumidor.ConsumidorPessoaJuridica.Fax.Numero }} </v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Endereco">Endereço</span>
    <v-row>
      <v-col cols="6" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Endereco?.Logradouro">
        <v-row class="text-subtitle font-weight-bold"> Endereço </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.Endereco.Logradouro }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Endereco?.Numero">
        <v-row class="text-subtitle font-weight-bold"> Número </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor?.ConsumidorPessoaJuridica?.Endereco?.Numero }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Endereco?.CEP">
        <v-row class="text-subtitle font-weight-bold"> CEP </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.Endereco.CEP }} </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Endereco?.Complemento">
        <v-row class="text-subtitle font-weight-bold"> Complemento</v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.Endereco.Complemento }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Endereco?.Bairro">
        <v-row class="text-subtitle font-weight-bold"> Bairro </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.Endereco.Bairro }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Endereco?.Cidade?.Nome">
        <v-row class="text-subtitle font-weight-bold"> Cidade </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.Endereco.Cidade.Nome }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5" v-if="model.Consumidor?.ConsumidorPessoaJuridica?.Endereco?.Cidade?.Estado?.SiglaUF">
        <v-row class="text-subtitle font-weight-bold"> UF </v-row>
        <v-row class="text-subtitle"> {{ model.Consumidor.ConsumidorPessoaJuridica.Endereco.Cidade.Estado.SiglaUF }} </v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="model.DadosAdicionaisDeContato?.DetalheDadosAdicionaisDeContato?.length > 0">Dados Adicionais de Contato</span>
    <v-row v-for="(item, i) in model.DadosAdicionaisDeContato?.DetalheDadosAdicionaisDeContato" :key="i">
      <v-col cols="12" v-if="item.Celulares?.length > 0">
        <v-row class="text-subtitle font-weight-bold">Celulares</v-row>
        <v-row
          v-for="(cel, cIndex) in item.Celulares"
          :key="cIndex"
          class="text-subtitle"
        >
          {{ cel }}
        </v-row>
      </v-col>
      <v-col cols="12" v-if="item.Telefones?.length > 0">
        <v-row class="text-subtitle font-weight-bold">Telefones</v-row>
        <v-row
          v-for="(tel, tIndex) in item.Telefones"
          :key="tIndex"
          class="text-subtitle"
        >
          {{ tel }}
        </v-row>
      </v-col>
      <v-col cols="12" v-if="item.Emails?.length > 0">
        <v-row class="text-subtitle font-weight-bold">E-mails</v-row>
        <v-row
          v-for="(email, eIndex) in item.Emails"
          :key="eIndex"
          class="text-subtitle"
        >
          {{ email }}
        </v-row>
      </v-col>
      <v-col cols="12" v-if="item.EnderecosPF?.length > 0">
        <v-row class="text-subtitle font-weight-bold">Endereços - Pessoa Física</v-row>
        <v-row
          v-for="(endpf, endpfIndex) in item.EnderecosPF"
          :key="endpfIndex"
          class="text-subtitle"
        >
          {{ endpf }}
        </v-row>
      </v-col>
      <v-col cols="12" v-if="item.EnderecosPJ?.length > 0">
        <v-row class="text-subtitle font-weight-bold">Endereços - Pessoa Juridica</v-row>
        <v-row
          v-for="(endpj, endpjIndex) in item.EnderecosPJ"
          :key="endpjIndex"
          class="text-subtitle"
        >
          {{ endpj }}
        </v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="model.UltimoEnderecoInformado?.DetalheUltimoEnderecoInformado?.length > 0">Último Endereço Informado</span>
    <v-row
      v-for="(item, index) in model.UltimoEnderecoInformado?.DetalheUltimoEnderecoInformado"
      :key="item.Endereco?.CEP + '-' + index"
      class="mb-6"
    >
      <v-col cols="12" v-if="item.Endereco">
        <v-row class="text-h6 font-weight-bold mb-2">
          Endereço {{ index + 1 }}
        </v-row>
      </v-col>

      <v-col cols="6" v-if="item.Endereco?.Logradouro">
        <v-row class="text-subtitle font-weight-bold">Endereço</v-row>
        <v-row class="text-subtitle">{{ item.Endereco.Logradouro }}</v-row>
      </v-col>

      <v-col cols="3" v-if="item.Endereco?.Numero">
        <v-row class="text-subtitle font-weight-bold">Número</v-row>
        <v-row class="text-subtitle">{{ item.Endereco.Numero }}</v-row>
      </v-col>

      <v-col cols="3" v-if="item.Endereco?.CEP">
        <v-row class="text-subtitle font-weight-bold">CEP</v-row>
        <v-row class="text-subtitle">{{ item.Endereco.CEP }}</v-row>
      </v-col>

      <v-col cols="3" v-if="item.Endereco?.Complemento">
        <v-row class="text-subtitle font-weight-bold">Complemento</v-row>
        <v-row class="text-subtitle">{{ item.Endereco.Complemento }}</v-row>
      </v-col>

      <v-col cols="3" v-if="item.Endereco?.Bairro">
        <v-row class="text-subtitle font-weight-bold">Bairro</v-row>
        <v-row class="text-subtitle">{{ item.Endereco.Bairro }}</v-row>
      </v-col>

      <v-col cols="3" v-if="item.Endereco?.Cidade?.Nome">
        <v-row class="text-subtitle font-weight-bold">Cidade</v-row>
        <v-row class="text-subtitle">{{ item.Endereco.Cidade.Nome }}</v-row>
      </v-col>

      <v-col cols="3" v-if="item.Endereco?.Cidade?.Estado?.SiglaUF">
        <v-row class="text-subtitle font-weight-bold">UF</v-row>
        <v-row class="text-subtitle">{{ item.Endereco.Cidade.Estado.SiglaUF }}</v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="model.Protesto?.DetalheProtesto?.length">Protestos</span>
    <v-col cols="12" v-if="model.Protesto?.DetalheProtesto?.length">
      <v-row class="text-h6">
        Resumo
      </v-row>
    </v-col>
    <v-row>
      <v-col cols="3" v-if="model.Protesto?.Resumo?.QuantidadeTotal">
        <v-row class="text-subtitle font-weight-bold">Qtd. Total</v-row>
        <v-row class="text-subtitle">{{ model.Protesto.Resumo.QuantidadeTotal }}</v-row>
      </v-col>
      <v-col cols="3" v-if="model.Protesto?.Resumo?.DataPrimeiraOcorrencia">
        <v-row class="text-subtitle font-weight-bold">Data da Primeira Ocorrência</v-row>
        <v-row class="text-subtitle">{{ $api.UI.Format.Date(model.Protesto.Resumo.DataPrimeiraOcorrencia) }}</v-row>
      </v-col>
      <v-col cols="3" v-if="model.Protesto?.Resumo?.DataUltimaOcorrencia">
        <v-row class="text-subtitle font-weight-bold">Data da Última Ocorrência</v-row>
        <v-row class="text-subtitle">{{ $api.UI.Format.Date(model.Protesto.Resumo.DataUltimaOcorrencia) }}</v-row>
      </v-col>
        <v-col cols="3" v-if="model.Protesto?.Resumo?.ValorTotal">
        <v-row class="text-subtitle font-weight-bold">Vlr. Total</v-row>
        <v-row class="text-subtitle">{{ model.Protesto.Resumo.ValorTotal }}</v-row>
      </v-col>
    </v-row>
    <v-expansion-panels focusable class="mb-3 mt-3" v-if="model.Protesto?.DetalheProtesto?.length">
      <v-expansion-panel>
        <v-expansion-panel-header class="primary--text">Protestos</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card
          v-for="(item, index) in model.Protesto?.DetalheProtesto"
          :key="item.NumeroProtesto + '-' + index"
          class="mb-6"
          >
            <v-row>
              <v-col cols="4" v-if="item.Cartorio?.Nome">
                <v-row class="text-subtitle font-weight-bold">Nome do Cartório</v-row>
                <v-row class="text-subtitle">{{ item.Cartorio.Nome }}</v-row>
              </v-col>
              <v-col cols="4" v-if="item.Cartorio?.Cidade?.Nome && item.Cartorio?.Cidade?.Estado?.SiglaUF">
                <v-row class="text-subtitle font-weight-bold">Cidade do Cartório</v-row>
                <v-row class="text-subtitle">{{ item.Cartorio.Cidade.Nome }} - {{ item.Cartorio.Cidade.Estado.SiglaUF }} </v-row>
              </v-col>
              <v-col cols="4" v-if="item.DataInclusao">
                <v-row class="text-subtitle font-weight-bold">Data de Inclusão</v-row>
                <v-row class="text-subtitle">{{ $api.UI.Format.Date(item.DataInclusao) }}</v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" v-if="item.DataProtesto">
                <v-row class="text-subtitle font-weight-bold">Data do Protesto</v-row>
                <v-row class="text-subtitle">{{ $api.UI.Format.Date(item.DataProtesto) }}</v-row>
              </v-col>
              <v-col cols="4" v-if="item.NumeroProtesto">
                <v-row class="text-subtitle font-weight-bold">Número do Protesto</v-row>
                <v-row class="text-subtitle">{{ item.NumeroProtesto }}</v-row>
              </v-col>
              <v-col cols="4" v-if="item.Valor">
                <v-row class="text-subtitle font-weight-bold">Valor</v-row>
                <v-row class="text-subtitle">{{ item.Valor }}</v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" v-if="item.RequerenteCredor">
                <v-row class="text-subtitle font-weight-bold">Requerente Credor</v-row>
                <v-row class="text-subtitle">{{ item.RequerenteCredor }}</v-row>
              </v-col>
              <v-col cols="4" v-if="item.CartaAnuencia">
                <v-row class="text-subtitle font-weight-bold">Carta Anuência</v-row>
                <v-row class="text-subtitle">{{ item.CartaAnuencia }}</v-row>
              </v-col>
              <v-col cols="4" v-if="item.DataCartaAnuencia">
                <v-row class="text-subtitle font-weight-bold">Data da Carta Anuência</v-row>
                <v-row class="text-subtitle">{{ $api.UI.Format.Date(item.DataCartaAnuencia) }}</v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <span class="text-h5 ml-3 primary--text" v-if="model.SPC?.DetalheSPC?.length">SPC</span>
    <v-col cols="12" v-if="model.SPC?.DetalheSPC?.length">
      <v-row class="text-h6">
        Resumo
      </v-row>
    </v-col>
    <v-row>
      <v-col cols="3" v-if="model.SPC?.Resumo?.QuantidadeTotal">
        <v-row class="text-subtitle font-weight-bold">Qtd. Total</v-row>
        <v-row class="text-subtitle">{{ model.SPC.Resumo.QuantidadeTotal }}</v-row>
      </v-col>
      <v-col cols="3" v-if="model.SPC?.Resumo?.DataPrimeiraOcorrencia">
        <v-row class="text-subtitle font-weight-bold">Data da Primeira Ocorrência</v-row>
        <v-row class="text-subtitle">{{ $api.UI.Format.Date(model.SPC.Resumo.DataPrimeiraOcorrencia) }}</v-row>
      </v-col>
      <v-col cols="3" v-if="model.SPC?.Resumo?.DataUltimaOcorrencia">
        <v-row class="text-subtitle font-weight-bold">Data da Última Ocorrência</v-row>
        <v-row class="text-subtitle">{{ $api.UI.Format.Date(model.SPC.Resumo.DataUltimaOcorrencia) }}</v-row>
      </v-col>
        <v-col cols="3" v-if="model.SPC?.Resumo?.ValorTotal">
        <v-row class="text-subtitle font-weight-bold">Vlr. Total</v-row>
        <v-row class="text-subtitle">{{ model.SPC.Resumo.ValorTotal }}</v-row>
      </v-col>
    </v-row>
    <v-expansion-panels focusable class="mb-3 mt-3" v-if="model.SPC?.DetalheSPC?.length">
      <v-expansion-panel>
        <v-expansion-panel-header class="primary--text">SPC</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card
          v-for="(item, index) in model.SPC?.DetalheSPC"
          :key="item.Contrato + '-' + index"
          class="mb-6"
          >
            <v-row>
              <v-col cols="3" v-if="item.NomeAssociado">
                <v-row class="text-subtitle font-weight-bold">Nome Associado</v-row>
                <v-row class="text-subtitle">{{ item.NomeAssociado }}</v-row>
              </v-col>
              <v-col cols="3" v-if="item.CidadeAssociado?.Nome && item.CidadeAssociado?.Estado?.SiglaUF">
                <v-row class="text-subtitle font-weight-bold">Cidade Associado</v-row>
                <v-row class="text-subtitle">{{ item.CidadeAssociado.Nome }} - {{ item.CidadeAssociado.Estado.SiglaUF }} </v-row>
              </v-col>
              <v-col cols="3" v-if="item.CodigoEntidade">
                <v-row class="text-subtitle font-weight-bold">Código Entidade</v-row>
                <v-row class="text-subtitle">{{ item.CodigoEntidade }}</v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" v-if="item.NomeEntidade">
                <v-row class="text-subtitle font-weight-bold">Nome Entidade</v-row>
                <v-row class="text-subtitle">{{ item.NomeEntidade }}</v-row>
              </v-col>
              <v-col cols="3" v-if="item.DataInclusao">
                <v-row class="text-subtitle font-weight-bold">Data de Inclusão</v-row>
                <v-row class="text-subtitle">{{ $api.UI.Format.Date(item.DataInclusao) }}</v-row>
              </v-col>
              <v-col cols="3" v-if="item.DataVencimento">
                <v-row class="text-subtitle font-weight-bold">Data de Vencimento</v-row>
                <v-row class="text-subtitle">{{ $api.UI.Format.Date(item.DataVencimento) }}</v-row>
              </v-col>
              <v-col cols="3" v-if="item.Valor">
                <v-row class="text-subtitle font-weight-bold">Valor</v-row>
                <v-row class="text-subtitle">{{ item.Valor }}</v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" v-if="item.Contrato">
                <v-row class="text-subtitle font-weight-bold">Contrato</v-row>
                <v-row class="text-subtitle">{{ item.Contrato }}</v-row>
              </v-col>
              <v-col cols="3" v-if="item.ContaContrato">
                <v-row class="text-subtitle font-weight-bold">Conta Contrato</v-row>
                <v-row class="text-subtitle">{{ item.ContaContrato }}</v-row>
              </v-col>
              <v-col cols="3" v-if="item.CompradorFiadorAvalista">
                <v-row class="text-subtitle font-weight-bold">Papel</v-row>
                <v-row class="text-subtitle">{{ item.CompradorFiadorAvalista }}</v-row>
              </v-col>
              <v-col cols="3">
                <v-row class="text-subtitle font-weight-bold">Registro Inst. Financ.</v-row>
                <v-row class="text-subtitle">{{ item.RegistroInstituicaoFinanceira === 0 ? 'NÃO' : 'SIM' }}</v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" v-if="!!item.RegistroRelevante">
                <v-row class="text-subtitle font-weight-bold">Registro Relevante</v-row>
                <v-row class="text-subtitle">{{ item.RegistroRelevante }}</v-row>
              </v-col>
              <v-col cols="3" v-if="item.Reservado">
                <v-row class="text-subtitle font-weight-bold">Reservado</v-row>
                <v-row class="text-subtitle">{{ item.Reservado }}</v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <span class="text-h5 ml-3 primary--text" v-if="model.SpcScore12Meses?.DetalheSpcScore12Meses?.length">Score SPC 12 Meses</span>
    <v-card
    v-for="(item, index) in model.SpcScore12Meses?.DetalheSpcScore12Meses"
    :key="item.Horizonte + '-' + index"
    class="mb-6 mt-4"
    >
      <v-row>
        <v-col cols="3" v-if="item.Classe">
          <v-row class="text-subtitle font-weight-bold">Classe</v-row>
          <v-row class="text-subtitle">{{ item.Classe }}</v-row>
        </v-col>
        <v-col cols="4" v-if="item.Horizonte">
          <v-row class="text-subtitle font-weight-bold">Horizonte</v-row>
          <v-row class="text-subtitle">{{ item.Horizonte }}</v-row>
        </v-col>
        <v-col cols="4" v-if="item.TipoClienteScore">
          <v-row class="text-subtitle font-weight-bold">Tipo Cliente Score</v-row>
          <v-row class="text-subtitle">{{ getTipoClienteScore(item.TipoClienteScore) }}</v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" v-if="item.Score">
          <v-row class="text-subtitle font-weight-bold">Score</v-row>
          <v-row class="text-subtitle">{{ item.Score }}</v-row>
        </v-col>
        <v-col cols="9" v-if="item.MensagemInterpretativaScore">
          <v-row class="text-subtitle font-weight-bold">Mensagem Interpretativa Score</v-row>
          <v-row class="text-subtitle">{{ item.MensagemInterpretativaScore }}</v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" v-if="item.Probabilidade">
          <v-row class="text-subtitle font-weight-bold">Probabilidade</v-row>
          <v-row class="text-subtitle">{{ item.Probabilidade }}</v-row>
        </v-col>
        <v-col cols="9" v-if="item.MensageminterpretativaProbabilidade">
          <v-row class="text-subtitle font-weight-bold">Mensagem Interpretativa Probabilidade</v-row>
          <v-row class="text-subtitle">{{ item.MensageminterpretativaProbabilidade }}</v-row>
        </v-col>
      </v-row>
    </v-card>

    <span class="text-h5 ml-3 primary--text" v-if="model.ConsultaRealizada?.DetalheConsultaRealizada?.length > 0">Consultas Realizadas</span>
    <v-col cols="12" v-if="model.ConsultaRealizada?.DetalheConsultaRealizada?.length">
      <v-row class="text-h6">
        Resumo
      </v-row>
    </v-col>
    <v-row>
      <v-col cols="3" v-if="model.ConsultaRealizada?.Resumo?.QuantidadeTotal">
        <v-row class="text-subtitle font-weight-bold">Qtd. Total</v-row>
        <v-row class="text-subtitle">{{ model.ConsultaRealizada.Resumo.QuantidadeTotal }}</v-row>
      </v-col>
      <v-col cols="3" v-if="model.ConsultaRealizada?.Resumo?.DataPrimeiraOcorrencia">
        <v-row class="text-subtitle font-weight-bold">Data da Primeira Ocorrência</v-row>
        <v-row class="text-subtitle">{{ $api.UI.Format.Date(model.ConsultaRealizada.Resumo.DataPrimeiraOcorrencia) }}</v-row>
      </v-col>
      <v-col cols="3" v-if="model.ConsultaRealizada?.Resumo?.DataUltimaOcorrencia">
        <v-row class="text-subtitle font-weight-bold">Data da Última Ocorrência</v-row>
        <v-row class="text-subtitle">{{ $api.UI.Format.Date(model.ConsultaRealizada.Resumo.DataUltimaOcorrencia) }}</v-row>
      </v-col>
        <v-col cols="3" v-if="model.ConsultaRealizada?.QuantidadeDiasConsultados && model.ConsultaRealizada?.DetalheConsultaRealizada?.length">
        <v-row class="text-subtitle font-weight-bold">Qtd. Dias Consultados</v-row>
        <v-row class="text-subtitle">{{ model.ConsultaRealizada.QuantidadeDiasConsultados }}</v-row>
      </v-col>
    </v-row>
    <v-expansion-panels focusable class="mb-3 mt-3" v-if="model.ConsultaRealizada?.DetalheConsultaRealizada?.length">
      <v-expansion-panel>
        <v-expansion-panel-header class="primary--text">Consultas</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card
          v-for="(item, index) in model.ConsultaRealizada?.DetalheConsultaRealizada"
          :key="item.NomeAssociado + '-' + index"
          class="mb-6 mt-6"
          >
            <v-row>
              <v-col cols="12" v-if="item.NomeAssociado">
                <v-row class="text-subtitle font-weight-bold">Nome do Associado</v-row>
                <v-row class="text-subtitle">{{ item.NomeAssociado }}</v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" v-if="item.OrigemAssociado?.Nome && item.OrigemAssociado?.Estado?.SiglaUF">
                <v-row class="text-subtitle font-weight-bold">Origem do Associado</v-row>
                <v-row class="text-subtitle">{{ item.OrigemAssociado.Nome }} - {{ item.OrigemAssociado.Estado.SiglaUF }}</v-row>
              </v-col>
              <v-col cols="4" v-if="item.NomeEntidadeOrigem">
                <v-row class="text-subtitle font-weight-bold">Entidade de Origem</v-row>
                <v-row class="text-subtitle">{{ item.NomeEntidadeOrigem }}</v-row>
              </v-col>
              <v-col cols="4" v-if="item.DataConsulta">
                <v-row class="text-subtitle font-weight-bold">Data da Consulta</v-row>
                <v-row class="text-subtitle">{{ $api.UI.Format.Date(item.DataConsulta) }}</v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default ({
  props: {
    model: {}
  },
  methods: {
    getTipoClienteScore (value) {
      const map = {
        0: 'NOVO',
        1: 'RESTRITO',
        2: 'NÃO RESTRITO'
      }
      return map[value] ?? '-'
    }
  }
})
</script>
